import jsonServerProvider from "ra-data-json-server";
import { apiUrl as serverUrl } from "./config";
import { httpClient } from "./httpClient";

let apiUrl = serverUrl

function setId(list: any) {
  if (list.length > 0) {
    return list.map((item: any, index: number) => ({
      ...item,
      // 如果已有id字段则使用，否则创建
      id: item.id || index + 1
    }))
  }
  return list
}

async function urlDataGetFile(response: any, defaultName: string) {
  if (!response.ok) {
    // 尝试解析错误信息（如果后端返回JSON格式的错误）
    const errorData = await response.json().catch(() => null);
    if (errorData) {
      throw new Error(errorData.message || `导出失败: ${response.statusText}`);
    } else {
      throw new Error(`导出失败: ${response.statusText}`);
    }
  }

  // 从Content-Disposition中获取文件名
  const contentDisposition = response.headers.get('content-disposition');


  let fileName = defaultName;

  // 确保文件名有正确的扩展名（根据Content-Type）
  const contentType = response.headers.get('Content-Type');
  if (!fileName.includes('.') && contentType) {
    const extension = getExtensionFromContentType(contentType);
    if (extension) {
      fileName = `${fileName}.${extension}`;
    }
  }


  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\n"']*)['"]?;?/i);
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1];
    }
  }


  if (contentDisposition) {
    // 处理各种格式的Content-Disposition
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches && matches[1]) {
      // 去除可能的引号并解码URL编码的文件名
      let extractedFilename = matches[1].replace(/['"]/g, '');

      // 处理UTF-8编码的文件名（形如：filename*=UTF-8''%E6%96%87%E4%BB%B6.xlsx）
      if (extractedFilename.startsWith("UTF-8''")) {
        extractedFilename = decodeURIComponent(extractedFilename.substring(5));
      } else if (extractedFilename.startsWith("UTF-8\'\'")) {
        extractedFilename = decodeURIComponent(extractedFilename.substring(5));
      } else if (extractedFilename.startsWith("utf-8")) {
        extractedFilename = decodeURIComponent(extractedFilename.substring(5));
      }

      fileName = extractedFilename || defaultName;
    }
  }

  // 创建blob并触发下载
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(downloadUrl);
}

// 辅助函数：根据Content-Type获取文件扩展名
function getExtensionFromContentType(contentType: string): string | null {
  const extensionMap: { [key: string]: string } = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-excel': 'xls',
    'application/pdf': 'pdf',
    'application/zip': 'zip',
    'application/json': 'json',
    'text/csv': 'csv',
    'text/plain': 'txt',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  };

  return extensionMap[contentType] || null;
}


const baseDataProvider = jsonServerProvider(apiUrl, httpClient); // 注意此处注入httpClient


let customerTypesCache: any = null;
let customerTypesLoading = false;

let mallMerchant: any = null;
let mallMerchantLoading = false;

let ManufacturerTypes: any = null;
let ManufacturerTypesLoading = false;


export const dataProvider = {
  ...baseDataProvider, // 继承原有方法

  getStockCount: async () => {
    try {
      const response = await httpClient(`${apiUrl}/device/device-inventory/stock-count`);
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取剩余库存失败");
    } catch (error: any) {
      throw error;
    } finally {
    }
  },

  getDeviceList: async () => {
    try {
      const response = await httpClient(`${apiUrl}/device/deviceType/list`);
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取设备类型失败");
    } catch (error: any) {
      throw error;
    }
  },

  getDeviceProfile: async (params: any) => {
    try {
      let query = {
        ...params
      };
      const response = await httpClient(`${apiUrl}/third-party/thingsboard/device/profile/infos?${new URLSearchParams(query)}`, {
        method: 'GET'
      });
      const data = response.json;
      if (data.code === 0) {
        return data.data.records;
      }
      throw new Error(data.message || "获取TB设备配置列表失败");
    } catch (error: any) {
      throw error;
    }
  },

  getSalesCustomers: async () => {
    try {
      const response = await httpClient(`${apiUrl}/account/sales-customers/enabled`);
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取用户类型失败");
    } catch (error: any) {
      throw error;
    } finally {
    }
  },

  // getProductModelList: async () => {
  //   try {
  //     const response = await httpClient(`${apiUrl}/device/productModel/list`);
  //     const data = response.json;
  //     if (data.code === 0) {
  //       return data.data;
  //     }
  //     throw new Error(data.message || "获取产品型号列表");
  //   } catch (error:any) {
  //     throw error;
  //   } finally {
  //   }
  // },

  getStrategyList: async () => {
    try {
      const response = await httpClient(`${apiUrl}/device/traffic/strategy/list`);
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取策略列表失败");
    } catch (error: any) {
      throw error;
    } finally {
    }
  },

  getRolesList: async () => {
    try {
      const response = await httpClient(`${apiUrl}/account/roles`);
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取角色列表失败");
    } catch (error: any) {
      throw error;
    } finally {
    }
  },

  getTrafficCustomers: async () => {
    try {
      const response = await httpClient(`${apiUrl}/account/traffic-customers/enabled`);
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取用户类型失败");
    } catch (error: any) {
      throw error;
    } finally {
    }
  },

  getManufacturerTypes: async () => {
    if (ManufacturerTypes) {
      return ManufacturerTypes;
    }
    if (ManufacturerTypesLoading) {
      console.log('请求正在进行中')
      return
    }

    ManufacturerTypesLoading = true;
    try {
      const response = await httpClient(`${apiUrl}/device/manufacturer/list`);
      const data = response.json;
      if (data.code === 0) {
        ManufacturerTypes = data.data;
        return ManufacturerTypes;
      }
      throw new Error(data.message || "获取用户类型失败");
    } catch (error: any) {
      throw error;
    } finally {
      ManufacturerTypesLoading = false;
    }
  },

  getCaptcha: async (params: { tokenId: string }) => {
    try {
      const response = await fetch(`${apiUrl}/account/pc/captcha/image`, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest' // 标识AJAX请求
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const tokenId = response.headers.get('tokenid');

      // 处理图片数据
      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);

      return {
        imageUrl,
        tokenId // 返回给前端用于后续验证
      };
    } catch (error) {
      console.error('验证码获取失败:', error);
      throw new Error(error.message || "验证码获取失败");
    }
  },

  otaPackage: async (params: any) => {
    let query = {
      ...params,
      pageNum: 1,
      pageSize: 50,
    };

    const response = await httpClient(
      `${apiUrl}/third-party/thingsboard/otaPackage?${new URLSearchParams(query)}`
    );

    const data = response.json;
    if (data.code === 0) {
      return data.data.records;
    }
    throw new Error(data.message || "获取ota包列表失败");
  },

  macImport: async (resource: any, params: any) => {
    const formData = new FormData();
    formData.append('file', params.data.file);

    try {
      const response = await httpClient(`${apiUrl}/device/mac-pool/import`, {
        method: 'POST',
        body: formData,
      });

      return { data: response.json.data };
    } catch (error: any) {
      throw error;
    }
  },

  deployScript: async (params: any) => {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('id', params.id);
    try {
      const response = await httpClient(`${apiUrl}/account/traffic-customers/setscript`, {
        method: 'POST',
        body: formData,
      });

      return { data: response.json.data };
    } catch (error: any) {
      throw error;
    }
  },

  fileAccount: async (formData: any) => {
    try {
      const response = await httpClient(`${apiUrl}/files/file/account`, {
        method: 'POST',
        body: formData,
      });

      return { data: response.json.data };
    } catch (error: any) {
      throw error;
    }
  },

  batchImport: async (resource: any, params: any) => {
    const formData = new FormData();
    formData.append('file', params.data.file);

    if (params.data.totalCount !== undefined) {
      formData.append('totalCount', params.data.totalCount.toString());
    }

    try {
      const response = await httpClient(`${apiUrl}/device/device-inventory/batch-in-stock`, {
        method: 'POST',
        body: formData
      });

      return { data: response.json.data };
    } catch (error: any) {
      throw error;
    }
  },


  getCustomerTypes: async () => {
    if (customerTypesCache) {
      return customerTypesCache;
    }

    if (customerTypesLoading) {
      console.log('请求正在进行中')
      return
    }

    customerTypesLoading = true;
    try {
      const response = await httpClient(`${apiUrl}/account/customer-types`);
      const data = response.json;
      if (data.code === 0) {
        customerTypesCache = data.data;
        return customerTypesCache;
      }
      throw new Error(data.message || "获取用户类型失败");
    } catch (error: any) {
      throw error;
    } finally {
      customerTypesLoading = false;
    }
  },

  // 自定义 getList 方法
  getList: async (resource: any, params: any) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    // console.log(resource:any, params:any)
    let query = {
      ...params.filter,      // 包含过滤参数
      pageNum: page,
      pageSize: perPage,
      sortField: field,
      sortOrder: order.toLowerCase()
    };
    let api = ''
    if (resource === 'trafficAccount') {
      api = '/account/traffic-customers/page'
    }
    if (resource === 'deviceAccount') {
      api = '/account/sales-customers/page'
    }

    if (resource === 'factoryTesting') {
      api = '/device/device-sn/page'
    }
    if (resource === 'equipment' || resource === 'equipmentDetails' || resource === 'deploy' || resource === 'xunleiDeploy') {
      api = '/device/device/page'
    }
    if (resource === 'strategy') {
      api = '/device/traffic/strategy/list'
    }
    if (resource === 'storeProduct' || resource === 'outboundQueryList') {
      api = '/device/device-inventory/page'
    }
    if (resource === 'outboundProduct') {
      api = '/device/device-inventory/out-stock/page/list'
    }
    if (resource === 'trafficRevenue') {
      api = '/device/device/traffic/income/page'
    }
    if (resource === 'deviceRevenue') {
      api = '/device/device/sales/income/page'
    }
    if (resource === 'otaUpgrade') {
      api = '/third-party/thingsboard/device/ota/page'
    }
    if (resource === 'upgradeSystem') {
      api = '/third-party/thingsboard/otaPackage'
    }
    if (resource === 'MACAddress') {
      api = '/device/mac-pool/page'
    }
    if (resource === 'userManage') {
      api = '/account/users'
    }
    if (resource == 'reconciliation') {
      api = '/account/reconciliation/findListPage'
    }
    if (resource == 'withdrawal') {
      api = '/account/withdrawal/findListPage'
    }
    if (resource == 'xunleiSnManage') {
      api = '/device/traffic/rtcs1/findListPage'
    }
    if (resource == 'otaUpgradeDetails') {
      api = '/third-party/thingsboard/device/ota/detail/page'
    }
    if (resource == 'trafficRevenueDetail') {
      api = '/device/device/traffic/income/detail/page'
    }
    if (resource == 'deviceRevenueDetail') {
      api = '/device/device/sales/income/detail/page'
    }

    if (api != '') {
      let res = await httpClient(`${apiUrl}${api}?${new URLSearchParams(query)}`, {
        method: 'GET'
      });

      if (!res.json.data.total && res.json.data.total != 0) {
        let dataWithId = setId(res.json.data)
        return { data: dataWithId, total: res.json.data.length };
      } else {
        let dataWithId = setId(res.json.data.records)
        return { data: dataWithId, total: res.json.data.total };
      }
    }

    // 其他资源走默认逻辑
    return baseDataProvider.getList(resource, params);
  },


  create: async (resource: any, params: any) => {
    let api = ''
    if (resource === 'trafficAccount') {
      api = '/account/traffic-customers'
    }
    if (resource === 'deviceAccount') {
      debugger
      api = '/account/sales-customers'
    }
    if (resource === 'factoryTesting') {
      api = '/device/device-sn/generate'
    }
    if (resource === 'storeProduct') {
      api = '/device/device-inventory/in-stock'
    }
    if (resource === 'strategy') {
      api = '/device/traffic/strategy/add'
    }
    if (resource === 'userManage') {
      api = '/account/users'
    }
    if (resource === 'outboundProduct') {
      api = '/device/device-inventory/out-stock/temp'
    }

    if (resource === 'upgradeSystem') {
      api = '/third-party/thingsboard/otaPackage';
      const formData = params.data;
      const { json } = await httpClient(`${apiUrl}${api}`, {
        method: 'POST',
        body: formData,
      });

      return {
        data: {
          id: json.id || Date.now(), // 使用合适的ID
          ...json
        }
      };
    }
    if (resource === 'outboundProduct/BatchCreate') {
      api = '/device/device-inventory/out-stock/temp/batchimport';
      const formData = params.data;
      const { json } = await httpClient(`${apiUrl}${api}`, {
        method: 'POST',
        body: formData,
      });

      return {
        data: {
          id: json.id || Date.now(), // 使用合适的ID
          ...json.data
        }
      };
    }

    const { json } = await httpClient(`${apiUrl}${api}`, {
      method: 'POST',
      body: JSON.stringify({
        ...params.data,
      }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });


    let id = json.data?.id

    if (resource === 'userManage') {
      id = params.data.username
    }
    // 确保返回格式符合React Admin要求
    return {
      data: {
        id: id,
        ...json.data
      }
    };
  },

  getOne: async (resource: any, params: any) => {
    let api = ''
    if (resource === 'trafficAccount') {
      api = '/account/traffic-customers/'
    }
    if (resource === 'deviceAccount') {
      api = '/account/sales-customers/'
    }

    if (resource === 'strategy') {
      api = '/device/traffic/strategy/'
    }
    if (resource === 'upgradeSystem') {
      api = '/third-party/thingsboard/otaPackage/'
    }

    if (resource === 'userManage') {
      api = '/account/users/'
    }

    if (resource === 'withdrawal') {
      api = '/account/withdrawal/'
    }
    const { id } = params;
    try {
      const response = await httpClient(`${apiUrl}${api}${id}`, {
        method: 'GET'
      });
      const data = response.json;

      // 检查响应是否成功
      if (data.code !== 0) {
        throw new Error(data.message || `获取${resource}详情失败`);
      }

      return { data: data.data };
    } catch (error: any) {
      console.error(`获取${resource}详情失败:`, error);
      // 抛出明确的错误信息，避免重试
      throw new Error(error.message || `获取${resource}详情失败`);
    }
  },


  update: async (resource: any, params: any) => {
    let { id, data } = params;

    let api = ''
    if (resource === 'trafficAccount') {
      api = '/account/traffic-customers'
    }
    if (resource === 'deviceAccount') {
      api = '/account/sales-customers'
    }
    if (resource === 'strategy') {
      api = '/device/traffic/strategy/update'
    }
    if (resource === 'upgradeSystem') {
      api = '/third-party/thingsboard/otaPackage'
    }
    if (resource === 'userManage') {
      data.userId = id
      api = '/account/users'
    }
    if (resource === 'reconciliation') {
      api = '/account/reconciliation/updateStatus'
    }
    if (resource === 'withdrawal') {
      api = '/account/withdrawal/updateStatus'
    }
    const response = await httpClient(`${apiUrl}${api}`, {
      method: 'PUT',
      body: JSON.stringify({ ...data, id })
    });
    return { data: { ...data, id } };
  },


  // 新增delete方法
  delete: async (resource: any, params: any) => {
    const urlMap: { [key: string]: string } = {
      trafficAccount: '/account/traffic-customers/',
      upgradeSystem: '/third-party/thingsboard/otaPackage/',
      deviceAccount: '/account/sales-customers/',
      userManage: '/account/users/',
      strategy: '/device/traffic/strategy/'
    };

    const url = urlMap[resource];
    if (!url) {
      throw new Error(`未知的资源类型: ${resource}`);
    }

    try {
      const response = await httpClient(`${apiUrl}${url}${params.id}`, {
        method: 'DELETE'
      });

      // 假设你的httpClient返回包含status和body的对象
      const responseData = response.json || response.body;

      // 根据后端返回的数据结构判断是否成功
      if (responseData && responseData.code === 3137) {
        throw new Error('删除失败：该策略正在被用户使用，无法删除');
      }

      // 如果后端使用HTTP状态码表示错误
      if (response.status >= 400) {
        const errorMessage = responseData?.message || `删除失败 (状态码: ${response.status})`;
        throw new Error(errorMessage);
      }

      return { data: { id: params.id } };

    } catch (error: any) {
      // 处理网络错误
      if (error instanceof TypeError) {
        throw new Error('网络错误，请检查网络连接');
      }

      // 处理已知的业务错误
      if (error.message.includes('3137') || error.message.includes('使用中')) {
        throw new Error('删除失败：该策略正在被用户使用，无法删除');
      }

      // 重新抛出其他错误
      throw error;
    }
  },

  disable: async (resource: any, params: any) => {
    if (resource === 'trafficAccount') {
      await httpClient(`${apiUrl}/account/traffic-customers/${params.id}/disable`, {
        method: 'PUT',
        body: JSON.stringify({ disableReason: params.data?.reason }) // 如果需要附加参数
      });
      return { data: { id: params.id } };
    }
    if (resource === 'deviceAccount') {
      await httpClient(`${apiUrl}/account/sales-customers/${params.id}/disable`, {
        method: 'PUT',
        body: JSON.stringify({ disableReason: params.data?.reason }) // 如果需要附加参数
      });
      return { data: { id: params.id } };
    }
    throw new Error('资源不支持禁用操作');
  },

  enable: async (resource: any, params: any) => {
    if (resource === 'trafficAccount') {
      await httpClient(`${apiUrl}/account/traffic-customers/${params.id}/enable`, {
        method: 'PUT',
        body: JSON.stringify({ disableReason: params.data?.reason }) // 如果需要附加参数
      });
      return { data: { id: params.id } };
    }
    if (resource === 'deviceAccount') {
      await httpClient(`${apiUrl}/account/sales-customers/${params.id}/enable`, {
        method: 'PUT',
        body: JSON.stringify({ disableReason: params.data?.reason }) // 如果需要附加参数
      });
      return { data: { id: params.id } };
    }
    throw new Error('资源不支持启用操作');
  },


  resetPassword: async (resource: string, params: { data: { userId: string; password: string } }) => {
    const url = `${apiUrl}/account/users/reset-password`;

    try {
      const response = await httpClient(url, {
        method: 'PUT', // 或根据后端要求使用 PUT
        body: JSON.stringify({
          userId: params.data.userId,
          password: params.data.password
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return { data: { success: true } };
      }
      throw new Error(data.message || "重置密码失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  setPassword: async (resource: string, params: { data: { oldPassword: string; newPassword: string } }) => {
    const url = `${apiUrl}/account/users/password`;

    try {
      const response = await httpClient(url, {
        method: 'PUT', // 或根据后端要求使用 PUT
        body: JSON.stringify({
          oldPassword: params.data.oldPassword,
          newPassword: params.data.newPassword
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return { data: { success: true } };
      }
      throw new Error(data.message || "密码修改失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },


  reconciliationBill: async (id?: any) => {
    const url = `${apiUrl}/account/reconciliation/bill/${id}`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "查看对账详情失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  cancelTempOutStock: async (id?: any) => {
    const url = `${apiUrl}/device/device-inventory/out-stock/temp/cancel/${id}`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
      });
      const data = response.json;
      if (data.code === 0) {
        return { data: { success: true } };
      }
      throw new Error(data.message || "取消暂存失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  confirmOutStock: async (id?: any) => {
    const url = `${apiUrl}/device/device-inventory/out-stock/confirm/${id}`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
      });
      const data = response.json;
      if (data.code === 0) {
        return { data: { success: true } };
      }
      throw new Error(data.message || "确认出库失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  startRunningVolume: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/start`;
    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "开始流量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  xunleiStartRunningVolume: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/rtcs1/start`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "开始流量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  // 添加获取用户信息的方法
  getUserInfo: async () => {
    const url = `${apiUrl}/account/users/info`;

    try {
      const response = await httpClient(url, {
        method: 'GET'
      });
      const data = response.json;
      if (data.code === 0) {
        return data.data;
      }
      throw new Error(data.message || "获取用户信息失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  generateTrafficSN: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/rtcs1/genTrafficSn`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "生成流量商 SN失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  countGenTrafficSn: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/rtcs1/countGenTrafficSn`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "生成流量商 SN数量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  xunleiGenerateTrafficSN: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/rtcs1/genTrafficSn`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "生成流量商 SN失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  startCount: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/rtcs1/start/count`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "统计跑量的设备数量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  exportTrafficSN: async (params?: any) => {
    const url = `${apiUrl}/traffic/task/trafficSnExport`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "导出流量设备SN失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  xunleiExportTrafficSN: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/xunlei/exportTrifficSnList?${new URLSearchParams(params)}`;

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '流量设备sn.xlsx')
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  deviceOtaExport: async (params?: any) => {
    const url = `${apiUrl}/third-party/thingsboard/device/ota/export?${new URLSearchParams(params)}`;

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '导出设备OTA列表.xlsx')
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  trafficIncomeExport: async (params?: any) => {
    const url = `${apiUrl}/device/device/traffic/income/export?${new URLSearchParams(params)}`;

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '导出设备流量收益数据.xlsx')
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  salesIncomeExport: async (params?: any) => {
    const url = `${apiUrl}/device/device/sales/income/export?${new URLSearchParams(params)}`;

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '导出导出设备销售权益数据.xlsx')
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  reconciliationExpor: async (id?: any) => {
    const url = `${apiUrl}/account/reconciliation/export/${id}`;
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, `reconciliation_${id}.xlsx`)
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  deviceExport: async (formData?: any) => {
    const url = `${apiUrl}/device/device/export?${new URLSearchParams(formData)}`;
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, `设备列表导出.xlsx`)
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  deviceInfoExport: async (formData?: any) => {
    const url = `${apiUrl}/device/traffic/exportDetial?${new URLSearchParams(formData)}`;
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, `设备列表导出.xlsx`)
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  withdrawExport: async (formData?: any) => {
    const url = `${apiUrl}/account/withdrawal/export?${new URLSearchParams(formData)}`;
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, `提现列表导出.xlsx`)
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  traffiCustomersExport: async (formData?: any) => {
    const url = `${apiUrl}/account/traffic-customers/export?${new URLSearchParams(formData)}`;
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, `流量客户导出.xlsx`)
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  exportTrifficSnList: async (formData?: any) => {
    const url = `${apiUrl}/device/traffic/rtcs1/exportTrifficSnList?${new URLSearchParams(formData)}`;
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, `网心SN管理列表.xlsx`)
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  setLogisticsNo: async (params?: any) => {
    const url = `${apiUrl}/device/device-inventory/out-stock/logisticsNo`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "设置物流信息失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  restoreFactorySettings: async (sn?: any) => {
    const url = `${apiUrl}/device/device/ops/restoreFactorySettings/${sn}`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "复位失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },


  startOtaUpgrade: async (params?: any) => {
    const url = `${apiUrl}/third-party/thingsboard/device/ota/upgrade`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "对设备升级版本失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  endRunningVolume: async (params?: any) => {
    const url = `${apiUrl}/device/traffic/stop`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "停止流量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  validateSn: async (id?: any) => {
    const response = await httpClient(`${apiUrl}/device/traffic/rtcs1/validateSn/${id}`, {
      method: 'POST'
    });
    return { data: response.json.data };
  },

  getTaskStats: async (id?: any) => {
    const response = await httpClient(`${apiUrl}/device/traffic/stats/${id}`, {
      method: 'GET'
    });
    return { data: response.json.data };
  },

  getProvinceList: async () => {
    const url = `${apiUrl}/device/province/list`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取省份列表失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  batchNoList: async () => {
    const url = `${apiUrl}/device/traffic/rtcs1/batchNoList`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const res = response.json;
      if (res.code === 0) {
        return res.data;
      }
      throw new Error(res.message || "获取所有流量任务的批次号失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getBatchList: async () => {
    const url = `${apiUrl}/device/traffic/batches`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取所有流量任务的批次号失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getLogInfo: async (id: any) => {
    const url = `${apiUrl}/device/device/ops/log/list/${id}`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取日志数据失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  opsLogInfo: async (id: any) => {
    const url = `${apiUrl}/device/device/ops/log/${id}`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "上报日志数据失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  validatePassword: async (params: any) => {
    const url = `${apiUrl}/account/users/validate-password`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "校验密码失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getYesterdayList: async () => {
    const url = `${apiUrl}/device/device/traffic/income/yesterday/stats`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取按流量客户分类统计昨日收益失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },


  getLast7daysList: async () => {
    const url = `${apiUrl}/device/device/traffic/income/last7days/ratio`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取分类统计近7天收益失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  expressInfo: async (params) => {
    const url = `${apiUrl}/third-party/express/info`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取物流信息失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getAmountRank: async () => {
    const url = `${apiUrl}/device/device/stat/salesCustomer/amountRank`;
    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取商户统计销售额排行榜失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getSalesCustomerLevel: async () => {
    const url = `${apiUrl}/device/device/stat/salesCustomer/level`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取销量分类统计销售商失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getUserStatDaily: async () => {
    const url = `${apiUrl}/third-party/mall/user/userStatDaily`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取注册用户统计图表失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getMallUserStat: async () => {
    const url = `${apiUrl}/third-party/mall/user/stat`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取注册用户统计失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  exportOutStockSn: async (formData: any) => {
    const url = `${apiUrl}/device/device-inventory/export-out-stock-sn?${new URLSearchParams(formData)}`;

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '导出已出库设备SN.xlsx')
      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  deviceSnExport: async (formData: any) => {
    const url = `${apiUrl}/device/device-sn/export?${new URLSearchParams(formData)}`;

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '序列号列表导出.xlsx')

      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  salesCustomersExport: async (formData: any) => {
    const url = `${apiUrl}/account/sales-customers/export?${new URLSearchParams(formData)}`;

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      urlDataGetFile(response, '导出销售客户信息.xlsx')

      // 返回一个成功的结果
      return { data: { success: true } };
    } catch (error: any) {
      console.error('导出失败:', error);
      throw new Error(error.message || '网络请求失败');
    }
  },

  getLast7daysActivation: async () => {
    const url = `${apiUrl}/device/device/last7days/activation`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取近7天设备激活数量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  deviceIncomeTotal: async () => {
    const url = `${apiUrl}/device/device/traffic/income/total`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取流量收益累计总额失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  totalExpenditure: async () => {
    const url = `${apiUrl}/account/sales-customers/stat/totalExpenses`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取支出数据失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  detectFault: async (params) => {
    const url = `${apiUrl}/device/device/ops/detectFault`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "故障诊断失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },


  updateRemark: async (params) => {
    const url = `${apiUrl}/account/withdrawal/updateRemark`;

    try {
      const response = await httpClient(url, {
        method: 'PUT',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "更新备注失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  frpcConfig: async (params) => {
    const url = `${apiUrl}/device/device/ops/frpcConfig`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "配置frpc失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },


  restartOps: async (sn) => {
    const url = `${apiUrl}/device/device/ops/restart/${sn}`;
    try {
      const response = await httpClient(url, {
        method: 'POST',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "下发设备重启失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  trafficCount: async (params) => {
    const url = `${apiUrl}/device/traffic/start/count`;

    try {
      const response = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        })
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "统计设备数量失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  trafficLast7daysTotalInchome: async () => {
    const url = `${apiUrl}/device/device/traffic/income/last7days/totalInchome`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取近7天流量商分配的总收益失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  salesLast7daysTotalInchome: async () => {
    const url = `${apiUrl}/device/device/sales/income/last7days/totalInchome`;

    try {
      const response = await httpClient(url, {
        method: 'GET',
      });
      const data = response.json;
      if (data.code === 0) {
        return data;
      }
      throw new Error(data.message || "获取近7天销售商获得的总收益失败");
    } catch (error: any) {
      throw new Error(error.message || '网络请求失败');
    }
  },

  getMallMerchant: async () => {
    if (mallMerchant) {
      return mallMerchant;
    }

    if (mallMerchantLoading) {
      console.log('请求正在进行中')
      return
    }

    mallMerchantLoading = true;
    try {
      const response = await httpClient(`${apiUrl}/third-party/mall/merchant/list`);
      const data = response.json;
      if (data.code === 0) {
        mallMerchant = data.data;
        return mallMerchant;
      }
      throw new Error(data.message || "获取商城销售商失败");
    } catch (error: any) {
      throw error;
    } finally {
      mallMerchantLoading = false;
    }
  },

};